import axios from 'axios';
import store from '@/store';
import endpointVersion from '@/helpers/endpoint-version';
export const putAudience = (params) => {
    const brand = store.getters.selectedBrand;
    const user = store.getters.user;
    const tokenV3 = store.state.auth.tokenV3;
    return axios.post('/audience/putAudience', {
        brand: brand.id,
        audience_name: params.name,
        audience_description: params.description,
        audience_user: user?.id,
        audience_query: params.query,
        audience_token: params.token,
        audience_expand: 0,
    }, {
        baseURL: endpointVersion('v3'),
        headers: { Authorization: `Bearer ${tokenV3}` },
    });
};
export const getCount = (query, audienceId) => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    return axios.get('/audience/getCount', {
        baseURL: endpointVersion('v3'),
        params: {
            brand: brand.id,
            ...(audienceId ? { audienceId: audienceId } : { audienceQuery: query }),
        },
        headers: { Authorization: `Bearer ${tokenV3}` },
        validateStatus: () => true,
    });
};
